import {gql} from '@apollo/client'

export const CREATE_AGENT_REFERRAL_INVITATION = gql`
  mutation createAgentReferralInvitation($email: String!) {
    createAgentReferralInvitation(email: $email) {
      invitationToken
      inviteUrl
      emailSent
      success
      errors {
        field
        message
      }
    }
  }
`
